import Divider from "v2/components/base/Divider/ui";
import { Col, Row } from "v2/components/base/Flex/ui";
import { ViewPoint } from "v2/components/base/ResponsiveLayout/ui";

const DetailPageLayout = ({
  FixedContent,
  ScrollableContent,
  isSubPage = false,
}: {
  FixedContent: React.ReactNode;
  ScrollableContent: React.ReactNode;
  isSubPage?: boolean;
}) => {
  return (
    <>
      <ViewPoint.Mobile>
        <Col
          sx={{ gap: "12px", maxHeight: "calc(100vh - 93px)", overflowY: "scroll" }}
          fullWidth
          fullHeight>
          <Col type="ss" fullWidth fullHeight>
            {FixedContent}
          </Col>
          <Divider.Row />
          <Col
            type="ss"
            sx={{
              gap: "8px",
            }}
            fullWidth
            fullHeight>
            {ScrollableContent}
          </Col>
          <Row sx={{ minHeight: "180px" }} fullWidth />
        </Col>
      </ViewPoint.Mobile>
      <ViewPoint.Desktop>
        <Row type="ss" sx={{ position: "relative", gap: "24px" }} fullWidth fullHeight>
          <Col
            type="ss"
            sx={{
              position: "sticky",
              left: "0",
              top: "0",

              ...(isSubPage
                ? {
                    flex: "0 0 40%",
                    maxWidth: "40%",
                  }
                : {
                    // maxWidth: "20%",
                    // flex: "0 0 auto",
                  }),
            }}
            // fullWidth
            fullHeight>
            {FixedContent}
          </Col>
          <Col
            type="ss"
            sx={{
              gap: "8px",
              overflowY: "scroll",
              maxHeight: "calc(100vh - 132px)",
              // flex: "0 0 auto",
            }}
            fullWidth>
            {ScrollableContent}
          </Col>
        </Row>
      </ViewPoint.Desktop>
    </>
  );
};

export default DetailPageLayout;
